import { Outlet, createFileRoute } from '@tanstack/react-router';

import { getHubStatusboardUrl } from '../../auth';
import { ScanWorkOrderButton } from '../../features/work-orders/scan-work-order-button';

export const Route = createFileRoute('/work-orders')({
  staticData: {
    // Neo has no Work Orders list page — this crumb hands off to the hub's
    // Statusboard (the legacy work orders list) instead of an internal route.
    breadcrumb: (match) => [
      { label: 'Work Orders', path: match.pathname, href: getHubStatusboardUrl() },
    ],
    // Shown top-right of the header on every /work-orders route — declared once
    // here, inherited by all children.
    headerActions: () => <ScanWorkOrderButton />,
  },
  component: WorkOrdersLayout,
});

function WorkOrdersLayout() {
  return <Outlet />;
}
